import { render, staticRenderFns } from "./appPayCenter.vue?vue&type=template&id=642ac89c&scoped=true"
import script from "./appPayCenter.vue?vue&type=script&lang=js"
export * from "./appPayCenter.vue?vue&type=script&lang=js"
import style0 from "./appPayCenter.vue?vue&type=style&index=0&id=642ac89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ac89c",
  null
  
)

export default component.exports